import React from 'react';
import {createPortal} from 'react-dom';
import {IModalProps} from './types';
import styles from './Modal.module.scss';

/**x
 * @deprecated use useModal hook instead
 */
export const Modal = ({open, handleOpen, children}: IModalProps) => {
    if (!open) {
        return <></>;
    }
    return createPortal(
        <div className={styles.modal}>
            <div className={styles.modal__overlay} onClick={handleOpen}/>
            <div className={styles.modal__content}>{children}</div>
        </div>, 
        document.body
    );
};

